import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { IonRouterOutlet, NavController } from '@ionic/angular/standalone';
import { AppStateService } from 'src/app/services/init/app-state.service';
import { InitService } from 'src/app/services/init/init.service';
import { CommonService } from 'src/app/services/common.service';
import { HomeService } from 'src/app/services/home.service';
import { IonButton, IonButtons, IonHeader, IonIcon, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { timer, take } from 'rxjs';

@Component({
  selector: 'back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss'],
  imports:[IonHeader,IonToolbar,IonButton,IonButtons,IonIcon,IonTitle,FormsModule,CommonModule]
})
export class BackButtonComponent implements OnInit {

  @Input("backPage") backPage: string;
  @Input("show") show: string;
@Input("select") select: string;
  @Input("color") color: string;
  @Input("buttonHiden") buttonHiden: string;
  currentUrl: string;
  myId = null;
  constructor(
    private router: Router,
    public navCtrl: NavController,
    public appState: AppStateService,
    private initService: InitService,
    private commandService : CommonService,
    private homeService: HomeService,
    public mainRouterOutlet: IonRouterOutlet
  

  ) { console.log("onBackButtonFunc component called"); 
}


  ngOnInit() {
    if (window.history.length > 1) {
    } else {
      window.history.back();
    }
  }

  // onBackButtonFunc() {
  //   this.currentUrl = this.router.url;
  //   const appData = this.appState.getAppData();
  //   if (this.select == 'home') {
  //     this.navCtrl.navigateRoot(['/tabs'])
  //   } else if (this.select == 'card') {
  //     this.router.navigate(['/tabs/subscription'])
  //   }
  //   else {
  //     if (this.mainRouterOutlet.canGoBack() || (this.initService.mainTabs && this.initService.mainTabs.outlet && this.initService.mainTabs.outlet.canGoBack() && window.history.length > 1)) { // ion-tab has its own router-outlet and "/tabs/*/*" URLs will be the part of ion-tab's ion-router-outlet.
  //         if(this.currentUrl == '/promotion-details' ){
  //           let footer = document.getElementById('footer')
  //           footer.style.display = 'none'
  //           //refactoring: use timer 
  //           timer(1000).pipe(take(1)).subscribe(() => {
  //             this.navCtrl.pop();
  //           });    
  //         } else{
  //             if(this.currentUrl == '/certificate-detail' && this.appState.previousUrl === "certificates-list"){
  //               this.navCtrl.setDirection('back');
  //               this.navCtrl.back();
  //             } else {
  //               this.navCtrl.pop();
  //             }
  //         }
  //     } else if (this.commandService.isLoggedIn && window.history.length < 1){
  //       this.router.navigateByUrl('/tabs/home');
  //     }
  //     else {
  //       this.router.navigateByUrl('/');
  //     }
      
  //   }
  // }


  //refactoring code with removing the nested if with Use a Map for this.currentUrl
  onBackButtonFunc() {
  this.currentUrl = this.router.url;
  const appData = this.appState.getAppData();

  const selectNavigationMap = {
    home: () => this.navCtrl.navigateRoot(['/tabs']),
    card: () => this.router.navigate(['/tabs/subscription']),
  };

  if (selectNavigationMap[this.select]) {
    selectNavigationMap[this.select]();
    return;
  }

  const canGoBack =
    this.mainRouterOutlet.canGoBack() ||
    (this.initService.mainTabs?.outlet?.canGoBack() && window.history.length > 1);

  const backNavigationMap = {
    '/promotion-details': () => {
      const footer = document.getElementById('footer');
      if (footer) footer.style.display = 'none';
      timer(1000).pipe(take(1)).subscribe(() => this.navCtrl.pop());
    },
    '/certificate-detail': () => {
      if (this.appState.previousUrl === 'certificates-list') {
        this.navCtrl.setDirection('back');
        this.navCtrl.back();
      } else {
        this.navCtrl.pop();
      }
    },
  };

  if (canGoBack && backNavigationMap[this.currentUrl]) {
    backNavigationMap[this.currentUrl]();
    return;
  }

  if (canGoBack) {
    this.navCtrl.pop();
  } else if (this.commandService.isLoggedIn && window.history.length < 1) {
    this.router.navigateByUrl('/tabs/home');
  } else {
    this.router.navigateByUrl('/');
  }
}

}

